{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "Good morning",
        "afternoon": "Good afternoon",
        "evening": "Good evening"
      },
      "header": {
        "fallbackUser": "User",
        "facility": "Facility {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} critical result requires acknowledgment",
        "message_other": "{{count}} critical results require acknowledgment",
        "reviewNow": "Review now"
      },
      "sections": {
        "overview": "Overview",
        "tasks": "Tasks",
        "myPatients": "My Patients",
        "recentActivity": "Recent Activity",
        "quickActions": "Quick Actions"
      },
      "stats": {
        "activeEncounters": "Active Encounters",
        "pendingOrders": "Pending Orders",
        "resultsToReview": "Results to Review",
        "criticalAlerts": "Critical Alerts"
      },
      "tasks": {
        "unsignedNotes": "Unsigned Notes",
        "criticalResultsPending": "Critical Results Pending",
        "cosignaturesNeeded": "Co-signatures Needed",
        "ordersToReview": "Orders to Review",
        "activeMedications": "Active Medications",
        "admissionsPending": "Admissions Pending",
        "ordersToVerify": "Orders to Verify",
        "controlledSubstanceReviews": "Controlled Substance Reviews",
        "systemAlerts": "System Alerts",
        "systemStatus": "System Status"
      },
      "systemStatusValue": {
        "healthy": "Healthy"
      },
      "empty": {
        "noPatients": "No active patient assignments.",
        "noTasks": "No role-specific tasks available.",
        "noRecentEncounters": "No recent encounters."
      },
      "quickActions": {
        "findPatient": {
          "label": "Find Patient",
          "description": "Search records"
        },
        "registerPatient": {
          "label": "Register Patient",
          "description": "Add new patient"
        },
        "viewCensus": {
          "label": "View Census",
          "description": "Active encounters"
        },
        "reports": {
          "label": "Reports",
          "description": "View analytics"
        }
      },
      "viewAll": "View All",
      "bedLabel": "Bed {{n}}",
      "admittedLabel": "Admitted {{date}}",
      "fallback": {
        "unknownPatient": "Unknown Patient",
        "unknownType": "Unknown"
      },
      "acuity": {
        "1": "Resuscitation",
        "2": "Emergent",
        "3": "Urgent",
        "4": "Less Urgent",
        "5": "Non-Urgent"
      },
      "encounterType": {
        "emergency": "Emergency",
        "inpatient": "Inpatient",
        "outpatient": "Outpatient",
        "observation": "Observation"
      },
      "encounterStatus": {
        "active": "Active",
        "completed": "Completed",
        "discharged": "Discharged",
        "cancelled": "Cancelled",
        "pending": "Pending"
      }
    },
    "qualityMeasures": {
      "title": "Quality Measures",
      "subtitle": "Track clinical quality metrics and regulatory compliance",
      "refresh": "Refresh",
      "allTypesLabel": "All Types",
      "allFacilitiesLabel": "All Facilities",
      "targetPrefix": "Target: {{value}} {{unit}}",
      "updatedPrefix": "Updated: {{value}}",
      "measureType": {
        "process": "Process",
        "outcome": "Outcome",
        "structure": "Structural"
      },
      "summary": {
        "totalMeasures": "Total Measures",
        "meetingTarget": "Meeting Target",
        "belowTarget": "Below Target"
      },
      "toasts": {
        "refreshSuccess": "Measures refreshed"
      },
      "results": {
        "title": "Recorded results",
        "period": "Period",
        "facility": "Facility",
        "denominator": "Denominator",
        "numerator": "Numerator",
        "exclusions": "Exclusions",
        "rate": "Rate",
        "source": "Source",
        "calculated": "Calculated",
        "empty": "No results recorded for this measure in this period.",
        "loadError": "Could not load recorded results.",
        "allFacilities": "All Facilities",
        "record": "Record result"
      },
      "sources": {
        "manual": "Manual",
        "sql-template": "SQL template",
        "import": "Import"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA report downloaded",
        "error": "QRDA download failed"
      },
      "record": {
        "title": "Record quality result",
        "titleFor": "Record result — {{code}} {{name}}",
        "subtitle": "Recorded results appear in the measure's history and flow into QRDA Category III exports. Re-recording a period replaces the earlier row.",
        "back": "Back to quality measures",
        "cancel": "Cancel",
        "save": "Record result",
        "measureNotFound": "Measure not found. It may have been deactivated.",
        "fields": {
          "periodStart": "Period start",
          "periodEnd": "Period end",
          "facility": "Facility",
          "allFacilities": "All Facilities",
          "denominator": "Denominator",
          "numerator": "Numerator",
          "exclusions": "Exclusions",
          "source": "Calculation source",
          "completeness": "Data completeness",
          "completenessHint": "Fraction of eligible records with complete data, 0 to 1. Leave blank if unknown.",
          "notes": "Notes"
        },
        "errors": {
          "periodStartRequired": "Period start is required",
          "periodEndRequired": "Period end is required",
          "periodOrder": "Period end must be on or after period start",
          "countInvalid": "Enter a whole number, 0 or more",
          "numeratorExceeds": "Numerator cannot exceed the denominator",
          "numeratorExceedsNet": "Numerator cannot exceed the denominator minus exclusions",
          "sourceRequired": "Calculation source is required",
          "completenessRange": "Completeness must be between 0 and 1"
        },
        "toast": {
          "success": "Result recorded",
          "error": "Recording failed"
        }
      }
    },
    "analyticsDashboard": {
      "title": "Analytics Dashboard",
      "subtitle": "Hospital performance metrics and trends",
      "refresh": "Refresh",
      "changeVsPrevPeriod": "{{sign}}{{value}}% vs prev period",
      "dateRange": {
        "today": "Today",
        "7d": "7D",
        "30d": "30D",
        "90d": "90D"
      },
      "facility": {
        "all": "All Facilities",
        "sgh": "SGH - Singapore General",
        "nuh": "NUH - National University Hospital",
        "ttsh": "TTSH - Tan Tock Seng Hospital"
      },
      "department": {
        "all": "All Departments",
        "er": "Emergency",
        "icu": "ICU",
        "medsurg": "Med/Surg",
        "peds": "Paediatrics",
        "maternity": "Maternity"
      },
      "widget": {
        "census": {
          "title": "Current Census"
        },
        "bedOccupancy": {
          "title": "Bed Occupancy"
        },
        "avgLOS": {
          "title": "Avg Length of Stay"
        },
        "throughput": {
          "title": "Total Encounters"
        },
        "readmission": {
          "title": "Pending Orders"
        }
      },
      "unit": {
        "patients": "patients",
        "days": "days",
        "encounters": "encounters",
        "orders": "orders"
      },
      "charts": {
        "admissionsVsDischarges": "Admissions vs Discharges",
        "admissionsByDepartment": "Admissions by Department",
        "encounterTypes": "Encounter Types",
        "censusTrend": "Census Trend",
        "insufficientData": "Insufficient data for chart",
        "insufficientTrendData": "Insufficient data for trend chart"
      },
      "series": {
        "admissions": "Admissions",
        "discharges": "Discharges",
        "census": "Census"
      },
      "toasts": {
        "refreshSuccess": "Dashboard refreshed"
      }
    },
    "reportRunner": {
      "title": "Report Runner",
      "subtitle": "Generate and export clinical, financial, and operational reports",
      "scheduleButton": "Schedule Report",
      "searchPlaceholder": "Search reports...",
      "allCategoriesLabel": "All Reports",
      "category": {
        "clinical": "Clinical",
        "financial": "Financial",
        "operational": "Operational",
        "quality": "Quality"
      },
      "emptyState": {
        "title": "Select a report to get started",
        "subtitle": "Choose from the report list on the left"
      },
      "noResults": "No reports match your filters",
      "parametersHeading": "Parameters",
      "selectOptionPlaceholder": "Select...",
      "runButton": "Run Report",
      "runningReport": "Running report...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "Date (facility-local)",
        "facilityTimeZone": "Facility timezone",
        "encounterDate": "Date (UTC)"
      },
      "resultSummary": {
        "rows": "Showing {{shown}} of {{total}} rows",
        "executed": "Executed in {{ms}}ms"
      },
      "toasts": {
        "success": "Report completed in {{executionTimeMs}}ms - {{rowCount}} rows",
        "failed": "Failed to run report",
        "missingFields": "Please fill required fields: {{missingFields}}",
        "exporting": "Exporting as {{format}}... (placeholder)",
        "scheduledPlaceholder": "Scheduled report setup (placeholder)"
      }
    }
  }
}
